import { ViewFactory } from 'src/3rds/cube-react'

import { UserProfileScope } from '../up_scopes'

import UserProfileView from './up_view'

export function registerViews(rv = ViewFactory.register) {
    rv(UserProfileScope, UserProfileView)
}
